<template>
  <div class="header">
    <!-- 分批付款标记 -->
    <img src="@/assets/user/stages.png" alt="" class="stages" v-if="detail.part_pay_status">
    <!-- 订单信息： -->
    <div class="label">{{ $t("message.orderInformation") }} :
      <!-- 供应商订单 -->
      <el-tag size="small" type="primary" class="primary" effect="dark"
        v-if="detail.order_extend.is_supplier_order">供应商订单</el-tag>
    </div>
    <div class="item">
      <!-- 客户名： -->
      <div style="  margin-bottom: 20px;">
        <span>{{ $t("message.customerName") }}:</span>
        <router-link
          :to="'/user/basicInformation?userID=' + detail.user.id + '&encryption=' + $md5(detail.user.id + '')"
          target="_blank" style="color: #fff;">
          {{ detail.user != null ? detail.user.realname : '' }}
        </router-link>

        <div class="attribute">
          <attributeName :name="detail.user_attribute" />
        </div>
      </div>
      <!-- 订单号： -->
      <p>
        <span>{{ $t("message.orderNumber") }}:</span>{{ detail.order_sn }}
      </p>
      <!--订单类型 -->
      <div>
        <span>{{ $t("message.orderType") }}: </span>
        <div class="attribute">
          {{ typeName(detail.type) }}
        </div>
        <!--  订单属性 -->
        <span>{{ $t("message.theOrderAttribute") }}: </span>
        <div class="attribute">
          <attributeName :name="detail.attribute_name" />
          <el-tag type="primary" effect="dark" size="mini" style="margin-top: 10px;"
            v-if="detail.auto_order">自动下单</el-tag>
        </div>
      </div>

    </div>
    <div class="border"></div>
    <div class="item">
      <!-- 业务员 -->
      <p>
        <span>{{ $t("message.salesman") }}:</span>{{ detail.y_admin != null ? detail.y_admin.realname : '' }}
      </p>
      <!-- 采购员 -->
      <p>
        <span>{{ $t("message.buyer") }}:</span>{{ detail.g_admin != null ? detail.g_admin.realname : '' }}
      </p>
      <!-- 配送员 -->
      <p>
        <span>{{ $t("message.distributionMember") }}:</span>{{ detail.p_admin != null ? detail.p_admin.realname : '' }}
      </p>
    </div>
    <div class="border"></div>

    <div class="item">
      <!-- 店铺数： -->
      <p>
        <span>{{ $t("message.numberOfStores") }}:</span>{{ detail.shop_count }}
      </p>
      <!-- 商品数 -->
      <p>
        <span>{{ $t("message.numberOfGoods") }}:</span>{{ detail.goods_count }}
      </p>
      <!-- 收件人 -->
      <p>
        <!-- 聊天 -->
        <a :href="'https://www.chatwork.com/#!rid' + detail.user.chatwork" target="_blank" v-if="detail.user.chatwork"
          style=" color: #fff;">
          <img src="@/assets/user/CW.svg" alt="" style="vertical-align: middle;">
          chatwork
        </a>
        <a style=" color: #fff;" @click="chat(item)" v-else href="javascript:;">
          <img src="@/assets/user/raku.svg" alt="" style=" vertical-align: middle;">
          RAKUCHAT
        </a>
      </p>
    </div>
    <div class="border"></div>
    <div class="item user_extend ">
      <!-- 注意事项 -->
      <span>{{ $t("message.mattersNeedingAttention") }}:</span>
      <textarea name="" id="" v-model="detail.user.user_extend.y_remark" readonly v-if="detail.user"></textarea>

    </div>
    <div class="userlink">
      <!-- 客户页面链接 -->
      <el-button size="mini" type="primary"
        @click="copy('https://www.rakumart.com/OrderDetails?order_sn=' + detail.order_sn)">
        {{ $t("message.userLink") }}
      </el-button>
    </div>
    <!-- 付完款后订单操作 -->
    <div class="btn option">
      <!-- option前置处理设置  采购确认完都可以设置 -->
      <div class="preServiceSet">
        <el-button type="success" @click="preServiceSet" size="mini" v-if="isAuth(765)">{{ $t("message.preServiceSet") }}</el-button>
      </div>
      <!--服务单明细查看  && isOptionService  v-if="isOptionService"-->
      <div class="preServicListDetail">
        <el-button type="success" @click="$refs.optionDetail.optionServiceList(detail.order_sn)" size="mini"
          class="primary">{{
            $t("message.viewServiceOrderDetail")
          }}</el-button>
      </div>
    </div>
    <!-- 订单操作 -->
    <div class="btn">
      <div>
        <!--  订单调整-->
        <div>
          <el-button type="success" size="mini" @click="orderAdjust">{{ $t("message.orderAdjust") }}</el-button>
        </div>
        <!-- 订单删除 -->
        <el-button type="primary" size="mini" @click="deleteOrder" v-if="isAuth(179)">{{ $t("message.deleteOrder")
        }}</el-button>
      </div>
    </div>
    <!-- 前置处理设置弹窗 -->
    <preServiceSet ref="preServiceSet" @saved="$emit('pre-service-saved')" />
    <!-- 服务单明细查看弹窗 -->
    <optionDetail ref="optionDetail" />
    <!-- 订单调整弹窗 -->
    <orderAdjust ref="orderAdjust" />
    <!-- 订单删除弹窗 -->
    <deleteOrder ref="deleteOrder" />
  </div>
</template>
<script>
import preServiceSet from './preServiceSet.vue'
import optionDetail from './optionDetail.vue'
import orderAdjust from '@/components/order/components/orderAdjust'
import deleteOrder from '@/components/order/components/deleteOrder'
export default {
  components: {
    preServiceSet,
    optionDetail,
    orderAdjust,
    deleteOrder,
  },
  props: {
    detail: {
      type: Object,
    },
  },
  computed: {
    typeList() {
      return this.$store.state.typeList;
    },
  },
  data() {
    return {
      isOptionService: false,
    };
  },
  mounted() {
    if (this.detail.status >= 50) {
      this.$api.optionServiceApi.optionServiceList({ order_sn: this.detail.order_sn, is_normal: 1 }).then((res) => {
        if (res.data.data != false) {
          this.isOptionService = true
        } else {
          this.isOptionService = false
        }
      });
    }
  },
  methods: {
    //打开聊天
    chat() {
      let japanUserRoleInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      let token = localStorage.getItem('japan_access_token')
      let iTop = (window.screen.availHeight - 30 - 700) / 2;
      //获得窗口的水平位置
      let iLeft = (window.screen.availWidth - 10 - 1260) / 2;
      if (location.host.indexOf('.co.jp') == -1) {
        window.open(
          `https://rakuchat.rakumart.com/admin_web/#/?id=JP${japanUserRoleInfo.id}&uid=${this.detail.user.id}&token=${token}`,
          japanUserRoleInfo,
          "height=700, width=1260, left=" +
          iLeft +
          ", top=" +
          iTop +
          ", toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no"
        );
      }
    },
    typeName(type) {
      let name = ''
      this.typeList.forEach(item => {
        if (item.key == type) {
          name = item.value
        }
      })
      return name
    },
    // 前置处理设置
    preServiceSet() {

      let selectedList = this.detail.status <= 40 ? this.$parent.checkedList : this.$parent.selectedList
      if (selectedList.length == 0) return this.$message.error('请选择番后再设置服务前置。')
      this.$refs.preServiceSet.selectedOrder = selectedList
      this.$refs.preServiceSet.preServiceGet()
    },

    // 订单调整
    orderAdjust() {
      this.$refs.orderAdjust.allotVal = {
        order_sn_set: [this.detail.order_sn],
        y_id: this.detail.y_id,
        g_id: this.detail.g_id,
        p_id: this.detail.p_id,
      };
      this.$refs.orderAdjust.typeData.order_sn = [this.detail.order_sn];
      this.$refs.orderAdjust.dialogVisible = true;
    },
    // 刷新订单列表
    refresh(type) {
      if (type == 1) {
        this.$parent.orderDetails()
      } else {
        setTimeout(() => {
          window.open("about:blank", "_top").close();
        }, 1000)
      }

    },
    // 订单删除
    deleteOrder() {
      this.$refs.deleteOrder.deleteData = {
        order_sn_set: [this.detail.order_sn],
        delete_reason: '',
      };

      this.$refs.deleteOrder.dialogVisible = true;
    },
  },
};
</script>
<style lang='scss' scoped>
.header {
  padding: 24px;
  background-color: #32323c;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  min-width: 1862px;
  position: relative;

  .userlink {
    position: absolute;
    top: 25px;
    right: 24px;
  }

  .btn {
    position: absolute;
    top: 65px;
    right: 24px;
    text-align: right;

    div {
      margin-bottom: 15px;
    }
  }

  .option {
    right: 124px;
    text-align: left;
  }



  .stages {
    position: absolute;
    top: 25px;
    left: 500px;
  }

  .label {
    margin-right: 60px;
    position: relative;

    .el-tag {
      position: absolute;
      bottom: 0;
      left: 0;

    }
  }

  .item {
    p {
      margin-bottom: 20px;

      span {
        display: inline-block;
        width: 80px;
      }

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .attribute {
      display: inline-block;
      width: 100px;
      vertical-align: middle;
      line-height: 18px;
    }
  }

  .border {
    margin: 0 80px;
    background-color: #545467;
    width: 1px;
  }
}

.user_extend {

  display: flex;

  textarea {
    width: 500px;
    height: 100%;
    background-color: #32323c;
    color: #fff;
    padding: 3px;
    resize: none;
    border: none;
    font-size: 14px;
  }
}
</style>
